/* ZAdvQuery
Versione 1.9.11 - 10 Aprile 2026 - Mauro Brasile
                 NEW: Introdotta autoconnessione se cade la sessione anche per la post
                 FIX: Fix errore __GetSQL, nella on success della loginwithtoken non veniva passato alcun valore
Versione 1.8.10 - 12 Giugno 2025 - Massimiliano Zirilli
                 FIX: Sempre problema fix errore __getSQL
Versione 1.8.9 - 04 Giugno 2025 - Mauro Brasile
                 FIX: La gestione del last token e lastpiva spostata tutta su libreria
Versione 1.8.8 - 04 Giugno 2025 - Federico Migliazzi
                 NEW: Introdotta autoconnessione se cade la sessione
Versione 1.7.8 - 30 Maggio 2025 - Simone Biancolilla
                 CHG: Ora l'id di Sessione viene inviata nell'header e non tramite url
Versione 1.6.8 - 18 Dicembre 2024 - Massimiliano Zirilli
                 FIX: La Session non è più obbligatoria per gestire le GetSQL
Versione 1.6.7 - 02 Novembre 2023 - Francesco Ardini
                  NEW: Risolto bug nel passaggio dei parametri extra alla PostSQL 
Versione 1.6.6 - 30 Ottobre 2023 - Francesco Ardini
                  NEW: Introdotta la possibilità di passare parametri extra alla PostSQL 
Versione 1.5.6 - 25 Ottobre 2023 - Francesco Ardini
                  FIX: Carica sempre il subhttperror. Eliminato check response
Versione 1.5.5 - 17 Ottobre 2023 - Francesco Ardini
                  FIX: Eliminate le operazioni blob non gestite "Delete" e "Select"
Versione 1.5.4 - 16 Ottobre 2023 - Francesco Ardini
                  CHG: Spostate la classe del blob e la costante delle operazioni sul blob dalla scheda Allegati del template
Versione 1.4.4 - 11 Ottobre 2023 - Francesco Ardini
                  NEW: Gestita la registrazione
Versione 1.3.4 - 12 Settembre 2023 - Mauro Brasile
                  NEW: Aggiunte le nuove procedure per la gestione degli allegati: GetAttachment e DeleteAttachment
Versione 1.2.4 - 26 Giugno 2023 - Massimiliano Zirilli
                  NEW: Completata la gestione del multiserver
                  FIX: Errore USER_NOT_LOGGED not defined che compariva a caso ogni tanto
Versione 1.1.4 - 16 Febbraio 2023 - Massimiliano Zirilli
                  FIX: Errore gestione errore extra script
Versione 1.1.3 - 28 Settembre 2022 - Mauro Brasile
                  NEW: aggiunta procedura ChangePassword
                  FIX: Mancava un encodeuricomponent
Versione 1.0.2 - 09 Settembre 2022 - Massimiliano Zirilli
                 FIX: Errore dell'errore di connessione al server
Versione 1.0.1 - 28 Luglio 2022 - Massimiliano Zirilli
                 FIX: Introdotto encodeURIComponent in alcuni parametri dove
                      sono stati dimenticati
Versione 1.0.0 - 22 Luglio 2022 - Massimiliano Zirilli
                 Prima versione
*/

export const OPERAZIONE_BLOB = {
                                  Inserimento   : 'I',
                                  Update        : 'U',
                                  Cancellazione : 'D'
                               }

export class TAdvQueryOggettoBlob
{
  constructor(Operazione, Blob, Type, Name, Prefisso)
  {
    this.Operazione = Operazione
    this.Blob       = Blob
    this.Type       = Type
    this.Name       = Name
    this.Prefisso   = Prefisso
  }
}

export const TAdvQueryErrors = 
{
  HTTP_OPERATION_OK          : 0,   
  HTTP_ERROR_NOT_LOGGED      : 1,
  HTTP_ERROR_LOST_PARAMETER  : 2,
  HTTP_ERROR_CONNECTION_SQL  : 3,
  HTTP_ERROR_SQL             : 4,
  HTTP_ERROR_WRONG_PASSWORD  : 5,
  HTTP_ERROR_WRONG_USER      : 6,
  HTTP_ERROR_MODEL_LOAD      : 7,
  HTTP_ERROR_PARAMETERS      : 8,
  HTTP_ERROR_ACCESS_DENIED   : 9,
  HTTP_ERROR_SMTP_GENERIC    : 10, 
  HTTP_ERROR_EXTRA_SCRIPT    : 11,
  HTTP_ERROR_SIGN_IN         : 12,
  HTTP_ERROR_SESSION_VAR     : 13,
  HTTP_ERROR_SESSION_ID      : 14,
  HTTP_ERROR_ROLE            : 15,
  HTTP_ERROR_MAIL_ATTACH     : 16,
  HTTP_ERROR_MULTISERVER     : 17,
  HTTP_ERROR_WRONG_TOKEN     : 18,
  HTTP_ERROR_WRONG_CUSTOMER  : 19,
  HTTP_ERROR_FILE_NOT_FOUND  : 20,
  HTTP_ERROR_CANNOT_DELETE   : 21,
}

import axios from 'axios'

export class TAdvQuery
{
  
  constructor(UrlServer)
  {
     this.UrlServer                = UrlServer;
     this.SessionId                = undefined;
     this.CurrentUserLogged        = false;
     this.PHPLogin                 = "Login.php";
     this.PHPLogout                = "Logout.php";
     this.PHPRegistrazione         = "Registrazione.php";
     this.PHPLoginWithToken        = "LoginWithToken.php";
     this.PHPConnection            = "Connection.php";
     this.PHPGetAttachment         = "GetAttachment.php";
     this.PHPDeleteAttachment      = "DeleteAttachment.php"
     this.PHPSendMail              = "SendMail.php";
     this.ParModel                 = "Model";
     this.ParNomeFile              = 'NomeFile';
     this.ParUsername              = "Username";
     this.ParPassword              = "Password";
     this.ParSessionId             = "SessionId";
     this.ParSelectQuery           = "SelectQuery";
     this.ParEditParams            = "EditParams";
     this.ParExtraScriptParameters = "Params";
     this.ParLsFileDaEliminare     = "LsFileDaEliminare";
     this.ParTokenRememberMe       = "TokenRememberMe";
     this.ParRememberMeEnabled     = "GetTokenRememberMe";
     this.ParPartitaIva            = "PartitaIVA";

     this.PHPChangePassword        = "ChangePassword.php";
     this.ParOldPassword           = "Password";
     this.ParNewPassword           = "NewPassword";
     this.LastToken                = null;
     this.LastPIVA                 = null;
     this.ErrorNotLogged           = "Utente non connesso"
  }

  CheckAnswerHTTP(Answer)
  {
    this.HTTPResponse = Answer.Response;  
    switch(Answer.Response)
    {
       case TAdvQueryErrors.HTTP_OPERATION_OK           : this.HTTPError = ''; break;
       case TAdvQueryErrors.HTTP_ERROR_NOT_LOGGED       : this.HTTPError = this.ErrorNotLogged; break;   
       case TAdvQueryErrors.HTTP_ERROR_LOST_PARAMETER   : this.HTTPError = 'Parametri mancanti'; break;
       case TAdvQueryErrors.HTTP_ERROR_CONNECTION_SQL   : this.HTTPError = 'Errore di connessione al server SQL'; break;
       case TAdvQueryErrors.HTTP_ERROR_SQL              : this.HTTPError = 'Query error'; break;
       case TAdvQueryErrors.HTTP_ERROR_WRONG_PASSWORD   : this.HTTPError = 'Password errata'; break;
       case TAdvQueryErrors.HTTP_ERROR_WRONG_USER       : this.HTTPError = 'Account errato'; break;
       case TAdvQueryErrors.HTTP_ERROR_MODEL_LOAD       : this.HTTPError = 'Errore di caricamento del modello'; break;
       case TAdvQueryErrors.HTTP_ERROR_PARAMETERS       : this.HTTPError = 'Parametri errati'; break; 
       case TAdvQueryErrors.HTTP_ERROR_ACCESS_DENIED    : this.HTTPError = 'Accesso negato. Sospetto attacco DDoS'; break;
       case TAdvQueryErrors.HTTP_ERROR_SMTP_GENERIC     : this.HTTPError = 'Errore invio email'; break;
       case TAdvQueryErrors.HTTP_ERROR_EXTRA_SCRIPT     : this.HTTPError = 'Errore script customizzato'; break;
       case TAdvQueryErrors.HTTP_ERROR_SIGN_IN          : this.HTTPError = 'Errore durante la registrazione'; break;
       case TAdvQueryErrors.HTTP_ERROR_SESSION_VAR      : this.HTTPError = 'Errore nelle variabili di sessione'; break; 
       case TAdvQueryErrors.HTTP_ERROR_SESSION_ID       : this.HTTPError = 'Impossibile ottenere il numero di sessione'; break;
       case TAdvQueryErrors.HTTP_ERROR_ROLE             : this.HTTPError = 'Non hai i diritti per accedere a questi dati'; break;
       case TAdvQueryErrors.HTTP_ERROR_MAIL_ATTACH      : this.HTTPError = 'Errore nell\'allegare un file ad una mail'; break;
       case TAdvQueryErrors.HTTP_ERROR_MULTISERVER      : this.HTTPError = 'Errore multiserver'; break;
       case TAdvQueryErrors.HTTP_ERROR_WRONG_TOKEN      : this.HTTPError = 'Token remember me errato'; break;
       case TAdvQueryErrors.HTTP_ERROR_WRONG_CUSTOMER   : this.HTTPError = 'Cliente sconosciuto'; break; 
       case TAdvQueryErrors.HTTP_ERROR_FILE_NOT_FOUND   : this.HTTPError = 'Errore file non trovato'; break; 
       case TAdvQueryErrors.HTTP_ERROR_CANNOT_DELETE    : this.HTTPError = 'Impossibile cancellare il file'; break; 
       default                                          : this.HTTPError = 'Errore sconosciuto [' + Answer.Response + ']'; break;
    }
    this.SubHTTPError = ''; 
    if(Answer.Response == undefined)
       this.SubHTTPError = Answer;
    else
    {
         if(Answer.Error != undefined)
            this.SubHTTPError += '[' + Answer.Error + ']';
    }
    return(Answer.Response == TAdvQueryErrors.HTTP_OPERATION_OK)
  }

  FindResults(Results,Name)
  {
    if(Results != undefined)
    {
       try
       {
         return Results.find(function(SingleResult)
         {
            return SingleResult.Name == Name;
         }).View;
       } 
       catch(Errore)
       {
         return undefined;
       }
    } 
    else return undefined;
  }

  __PostSQL(Modello, Oggetto, OnSuccess, OnError, InvioMail = false, ExtraParameters)
  {
    let Self           = this;
    let Url            = this.UrlServer + (InvioMail ? this.PHPSendMail : this.PHPConnection);
    let Parametri      = '';
    var AltriParametri = '';

    if(ExtraParameters != undefined)
    {
      AltriParametri = '';

      for(var k in ExtraParameters) 
        AltriParametri += "&" + k + '=' + encodeURIComponent(ExtraParameters[k]);
    }

    Parametri = this.ParModel + "=" + encodeURIComponent(Modello) + "&" + 
                this.ParEditParams + "=" + encodeURIComponent(JSON.stringify(Oggetto)) + '&' + 
                AltriParametri;

    axios.post(Url, Parametri, { headers: { 'ParSessionId': this.SessionId } })
         .then(function(Answer)
         {
           if(Self.CheckAnswerHTTP(Answer.data))
           {
             if(OnSuccess != undefined)
               OnSuccess(Answer.data);
           }
           else OnError(Self.HTTPError, Self.SubHTTPError,Answer.data.Response);
         })
         .catch(function(Error)
         {
           OnError(Error.message,'');
         });
  }

  PostSQL(Modello, Oggetto, OnSuccess, OnError, InvioMail = false, ExtraParameters)
  {
      let Self = this
      this.__PostSQL(Modello, Oggetto, OnSuccess, 
                    function (Error,SubError) 
                    {
                        if(Error == Self.ErrorNotLogged && Self.CurrentUserLogged)
                        {
                          Self.LoginWithToken(Self.LastToken,
                                              function () 
                                              {
                                                Self.__PostSQL(Modello, Oggetto, OnSuccess, OnError, InvioMail, ExtraParameters)
                                              },
                                              OnError,
                                              Self.LastPIVA) 
                        }
                        else OnError(Error,SubError)
                    },
                    InvioMail, 
                    ExtraParameters);
  }

  ExecuteExternalScript(ExternalScript, Parametri, OnSuccess, OnError) 
  {
    var Self              = this;
    let Url               = this.UrlServer + ExternalScript + '.php';
    let ParametriChiamata = (Parametri != undefined ? this.ParExtraScriptParameters + "=" + encodeURIComponent(JSON.stringify(Parametri)) : ""); 

    axios.post(Url, ParametriChiamata, { headers: { 'ParSessionId': this.SessionId } })
         .then(function(Answer) 
         {
            if(Self.CheckAnswerHTTP(Answer.data))
            {
               if (OnSuccess != undefined)
                OnSuccess(Answer.data);
            }
            else OnError(Self.HTTPError, 
                         Self.SubHTTPError,
                         Answer.Response); 
         })
         .catch(function(Error) 
         {
            OnError(Error.message, '');
         });
  }

  __GetSQL(Modello, Parametri, OnSuccess, OnError, NomeQuery)
  {
    let Self   = this;
    let Url    = this.UrlServer + this.PHPConnection + "?" + this.ParModel + "=" + encodeURIComponent(Modello);

    if(NomeQuery != undefined)
      Parametri[this.ParSelectQuery] = NomeQuery;

    for(var k in Parametri) 
      Url += '&' + k + '=' + encodeURIComponent(Parametri[k]);

    axios.get(Url, { headers: { 'ParSessionId': this.SessionId } })
         .then(function(Answer)
         {
           try
           {
             if(Self.CheckAnswerHTTP(Answer.data))
               OnSuccess(Answer.data.Results);
             else
               OnError(Self.HTTPError, 
                           Self.SubHTTPError + Answer.data.OtherInformations != undefined ? ('INFO -> ' + Answer.data.OtherInformations) : '',
                           Answer.data.Response);
           }
           catch(e)
           {
               OnError(e,"");
           }
         })
         .catch(function(Error) 
         {
           OnError(Error, '');
         });
  }

  GetSQL(Modello,Parametri,OnSuccess,OnError,NomeQuery)
  {
      let Self = this
      this.__GetSQL(Modello, 
                    Parametri, 
                    OnSuccess,
                    function (Error,SubError) 
                    {
                        if(Error == Self.ErrorNotLogged && Self.LastToken != null)
                        {
                          Self.LoginWithToken(Self.LastToken,
                                              function () 
                                              {
                                                Self.__GetSQL(Modello,Parametri,OnSuccess,OnError,NomeQuery)
                                              },
                                              OnError,
                                              Self.LastPIVA) 
                        }
                        else OnError(Error,SubError)
                    },
                    NomeQuery);
  }

  Login(UserName,Password,AskRememberMe,OnSuccess,OnError,PartitaIVA) 
  {
    var self = this;
    axios.post(this.UrlServer + this.PHPLogin, 
               this.ParUsername + '=' + encodeURIComponent(UserName) + 
               '&' + this.ParPassword + '='+ encodeURIComponent(Password) +
               (PartitaIVA == undefined ? '' : '&' + this.ParPartitaIva + '='+ encodeURIComponent(PartitaIVA)) + 
               (AskRememberMe ? "&" + this.ParRememberMeEnabled + "=1" : ""))
         .then(function(Answer) 
         {
            try
            {
              if(self.CheckAnswerHTTP(Answer.data))
              {
                 self.SessionId         = Answer.data.SessionID;
                 self.CurrentUserLogged = true;
                 self.LastToken         = Answer.data.TokenRememberMe;
                 self.LastPIVA          = PartitaIVA;
                 OnSuccess(Answer.data.TokenRememberMe);
              }
              else OnError(self.HTTPError, self.SubHTTPError,Answer.data.Response); 
            }
            catch(e)
            {
              OnError(e,"");
            }
         })
         .catch(function(Error) 
         {
           OnError(Error.message,'');
         });
  }

  Logout(OnSuccess,OnError)
  {
    var Self = this;
    var URL = this.UrlServer + this.PHPLogout;
    var Parametri = '';
    if(this.SessionId != undefined)
       Parametri =  this.ParSessionId + '=' + encodeURIComponent(this.SessionId);
    axios.post(URL,Parametri)
         .then(function(Answer) 
         {
            try
            {
              if(Self.CheckAnswerHTTP(Answer.data))
              {
                 Self.CurrentUserLogged = false;
                 OnSuccess(Answer.data);
              }
              else OnError(Self.HTTPError, Self.SubHTTPError,Answer.data.Response); 
            }
            catch(e)
            {
              OnError(e,"");
            }
         })
         .catch(function(Error) 
         {
           OnError(Error.message,'');
         });
  }

  Registra(Parametri,OnSuccess,OnError)
  {
    var self = this;
    let Properties = Object.keys(Parametri)
    let Argomento = ''
    let Contatore = 0
    for (let i in Parametri)
    {
      if (Argomento != '')
        Argomento = Argomento + '&'
      Argomento = Argomento + Properties[Contatore] + "=" + encodeURIComponent(Parametri[i])
      Contatore++
    }
    axios.post(this.UrlServer + (this.PHPRegistrazione), 
               Argomento)
         .then(function(Answer) 
         {
            if(self.CheckAnswerHTTP(Answer.data))
            {
               if(OnSuccess != undefined)
                  OnSuccess(Answer.data);
            }
            else OnError(self.HTTPError, self.SubHTTPError,Answer.data.Response); 
         })
         .catch(function(Error) 
         {
            OnError(Error.message,'');
         });
  }

  ChangePassword(VecchiaPassword,NuovaPassword,OnSuccess,OnError)
  {
      var self = this;
      axios.post(this.UrlServer + this.PHPChangePassword, 
                 this.ParOldPassword + "=" + encodeURIComponent(VecchiaPassword) + 
                 "&" + this.ParNewPassword + "=" + encodeURIComponent(NuovaPassword) +
                 '&' + this.ParSessionId + '=' + encodeURIComponent(this.SessionId))
         .then(function(Answer) 
         {
            if(self.CheckAnswerHTTP(Answer.data))
            {
               if(OnSuccess != undefined)
                  OnSuccess(Answer.data)
            }
            else OnError(self.HTTPError, self.SubHTTPError,Answer.data.Response)
         })
         .catch(function(Error) 
         {
            OnError(Error.message,'')
         })
  }

  LoginWithToken(Token,OnSuccess,OnError,PartitaIVA) 
  {
    var self = this;
    axios.post(this.UrlServer + this.PHPLoginWithToken, 
               this.ParTokenRememberMe + '=' + encodeURIComponent(Token) + 
               (PartitaIVA == undefined ? '' : '&' + this.ParPartitaIva + '='+ encodeURIComponent(PartitaIVA))
               )
         .then(function(Answer) 
         {
            try
            {
              if(self.CheckAnswerHTTP(Answer.data))
              {
                 self.SessionId         = Answer.data.SessionID;
                 self.CurrentUserLogged = true;
                 self.LastToken         = Token;
                 self.LastPIVA          = PartitaIVA;
                 OnSuccess();
              }
              else OnError(self.HTTPError, self.SubHTTPError,Answer.data.Response); 
            }
            catch(e)
            {
              OnError(e,"");
            }
         })
         .catch(function(Error) 
         {
           OnError(Error.message,'');
         });
  }

  GetAttachment(Path, OnSuccess, OnError)
  {   
    var URL = this.UrlServer + this.PHPGetAttachment + "?" + this.ParNomeFile + "=" + encodeURIComponent(Path) + '&' + 
              this.ParSessionId + '=' + encodeURIComponent(this.SessionId);
    var self = this;
    axios.get(URL)
      .then(function(Answer) 
      {
         try
         {
           if(self.CheckAnswerHTTP(Answer.data))
             OnSuccess(Answer.data.Allegato);
           else OnError(self.HTTPError, 
                        self.SubHTTPError + Answer.data.OtherInformations != undefined ? ('INFO -> ' + Answer.data.OtherInformations) : '',
                        Answer.data.Response);
         }
         catch(e)
         {
            OnError(e,"");
         }
      })
      .catch(function(Error) 
      {
        OnError(Error, '');
      });
  }

  DeleteAttachment(LsFileDaEliminare, OnSuccess, OnError)
  {
      var self = this;
      axios.post(this.UrlServer + this.PHPDeleteAttachment,
                 this.ParLsFileDaEliminare + "=" + encodeURIComponent(JSON.stringify(LsFileDaEliminare)) + 
                 '&' + this.ParSessionId + '=' + encodeURIComponent(this.SessionId))
            .then(function(Answer) 
            {
               if(self.CheckAnswerHTTP(Answer.data))
               {
                  if(OnSuccess != undefined)
                     OnSuccess(Answer.data);
               }
               else OnError(self.HTTPError, 
                            self.SubHTTPError,
                            Answer.Response); 
            })
            .catch(function(Error) 
            {
               OnError(Error.message, '');
            });
  }
}